import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 12c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3s-1.346 3-3 3h-9v-3zm14.166 3c.516-.886.834-1.902.834-3 0-3.308-2.692-6-6-6h-6c-3.308 0-6 2.692-6 6v3H6v18c0 4.962 4.038 9 9 9h18c4.962 0 9-4.038 9-9V15h-9.834z",
    clipRule: "evenodd"
  }))
};
export var BagFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});